import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiAward, FiCheck } from 'react-icons/fi';

interface CriteriaPageProps {}

export default function CriteriaPage({}: CriteriaPageProps) {
  const { t } = useTranslation();
  const { badgeId } = useParams();

  // In a real application, you would fetch the badge criteria from your backend
  // This is just a mock example
  const badgeCriteria = {
    'html-master': {
      name: 'HTML Master',
      description: 'Completed all HTML fundamentals courses with excellence',
      requirements: [
        'Complete all HTML fundamentals tutorials',
        'Score 90% or higher on all HTML challenges',
        'Complete the final HTML project with all requirements met',
        'Help at least one other student in the community'
      ],
      rewards: [
        'HTML Master badge',
        'Special profile badge icon',
        '500 XP bonus',
        'Access to advanced HTML challenges'
      ]
    }
  }[badgeId || ''] || null;

  if (!badgeCriteria) {
    return (
      <div className="container mx-auto p-4 mt-12 sm:mt-16">
        <div className="card bg-base-200 shadow-xl">
          <div className="card-body">
            <h1 className="text-2xl font-bold text-error">Badge não encontrada</h1>
            <p className="text-base-content/70">
              Os critérios para esta badge não foram encontrados.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 mt-12 sm:mt-16">
      <div className="card bg-base-200 shadow-xl">
        <div className="card-body">
          {/* Header */}
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
              <FiAward className="w-8 h-8 text-primary" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-primary">{badgeCriteria.name}</h1>
              <p className="text-base-content/70">{badgeCriteria.description}</p>
            </div>
          </div>

          {/* Requirements */}
          <div className="mb-8">
            <h2 className="text-xl font-bold mb-4">Requisitos</h2>
            <div className="grid gap-3">
              {badgeCriteria.requirements.map((req, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 p-3 bg-base-300 rounded-lg"
                >
                  <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                    <FiCheck className="w-4 h-4 text-primary" />
                  </div>
                  <span>{req}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Rewards */}
          <div>
            <h2 className="text-xl font-bold mb-4">Recompensas</h2>
            <div className="grid gap-3">
              {badgeCriteria.rewards.map((reward, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 p-3 bg-base-300 rounded-lg"
                >
                  <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                    <FiAward className="w-4 h-4 text-primary" />
                  </div>
                  <span>{reward}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 